module.exports = __webpack_public_path__ + "static/media/quiz-hint-1-en.a17fadf5.vtt";